var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-seo-rules"},[_c('div',{staticClass:"c-seo-rules__nav"},[_c('app-tabs',{attrs:{"variant":"pills","label":"SEO rules sections","tabs":_vm.seoTabs,"value":_vm.selectedTab.key},on:{"input":_vm.changeActiveTab}})],1),_c(_vm.selectedTab.component,{key:_vm.selectedTab.key,tag:"component",attrs:{"website":_vm.website}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }